import React from "react";
import { t } from "@auto/services";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { closeContextMenu, openContextMenu } from "../state";
import { useObservable } from "../hooks";
import { canCreateGeographyEntity, canUpdateGeographyEntity } from "@src/security/permissions";

const GeographyContextMenu = ({ gui, state, setState, events }) => {
  const contextMenu = state.contextMenu;
  const contextType = contextMenu?.type;
  const contextItem = contextMenu?.item;

  const handleOpen = React.useCallback(({ event, type, item }) => {
    openContextMenu(setState, event, type, item);
  }, [setState]);

  const handleClose = React.useCallback(() => {
    closeContextMenu(setState);
  }, [setState]);

  useObservable(events.contextMenuOpened, handleOpen);
  useObservable(events.contextMenuClosed, handleClose);

  const createChild = (entity, parentType) => {
    events.createRequested.publish({ entity, parent: contextItem, parentType });
  };

  return (
    <Menu
      open={!!contextMenu}
      onClose={() => events.contextMenuClosed.publish()}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenu
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
    >
      {contextType === "department" && canCreateGeographyEntity(gui, "arrondissement") ? (
        <MenuItem onClick={() => createChild("arrondissement", "department")}>
          {t("geo.addArrondissement")}
        </MenuItem>
      ) : null}

      {contextType === "arrondissement" && canCreateGeographyEntity(gui, "commune") ? (
        <MenuItem onClick={() => createChild("commune", "arrondissement")}>
          {t("geo.addCommune")}
        </MenuItem>
      ) : null}

      {contextType === "constituency" && canCreateGeographyEntity(gui, "commune") ? (
        <MenuItem onClick={() => createChild("commune", "constituency")}>
          {t("geo.addCommune")}
        </MenuItem>
      ) : null}

      {contextType === "commune" && canCreateGeographyEntity(gui, "section") ? (
        <MenuItem onClick={() => createChild("section", "commune")}>
          {t("geo.addSection")}
        </MenuItem>
      ) : null}

      {contextType === "section" && canCreateGeographyEntity(gui, "voting-center") ? (
        <MenuItem onClick={() => createChild("voting-center", "section")}>
          {t("geo.addVotingCenter")}
        </MenuItem>
      ) : null}

      {contextType && canUpdateGeographyEntity(gui, contextType) ? (
        <MenuItem onClick={() => events.editRequested.publish({ entity: contextType, item: contextItem })}>
          {t("common.edit")}
        </MenuItem>
      ) : null}

    </Menu>
  );
};

export default GeographyContextMenu;
